/******************************************************************************
 * GENERATED by scripts/generateHooks.ts — DO NOT EDIT.
 * Re-run with `pnpm zen3:generate`.
 ******************************************************************************/

/* eslint-disable */

import { useModelQueries, type ModelQueryHooks } from '@zenstackhq/tanstack-query/react';
import { schema } from '../zen3/schema-lite';

type Hooks = ModelQueryHooks<typeof schema, 'Factoid'>;
const hooks = useModelQueries(schema, 'Factoid');

export const useAggregateFactoid: Hooks['useAggregate'] = hooks.useAggregate;
export const useCountFactoid: Hooks['useCount'] = hooks.useCount;
export const useCreateFactoid: Hooks['useCreate'] = hooks.useCreate;
export const useCreateManyFactoid: Hooks['useCreateMany'] = hooks.useCreateMany;
export const useCreateManyAndReturnFactoid: Hooks['useCreateManyAndReturn'] = hooks.useCreateManyAndReturn;
export const useDeleteFactoid: Hooks['useDelete'] = hooks.useDelete;
export const useDeleteManyFactoid: Hooks['useDeleteMany'] = hooks.useDeleteMany;
export const useExistsFactoid: Hooks['useExists'] = hooks.useExists;
export const useFindFirstFactoid: Hooks['useFindFirst'] = hooks.useFindFirst;
export const useFindManyFactoid: Hooks['useFindMany'] = hooks.useFindMany;
export const useFindUniqueFactoid: Hooks['useFindUnique'] = hooks.useFindUnique;
export const useGroupByFactoid: Hooks['useGroupBy'] = hooks.useGroupBy;
export const useInfiniteFindManyFactoid: Hooks['useInfiniteFindMany'] = hooks.useInfiniteFindMany;
export const useSuspenseAggregateFactoid: Hooks['useSuspenseAggregate'] = hooks.useSuspenseAggregate;
export const useSuspenseCountFactoid: Hooks['useSuspenseCount'] = hooks.useSuspenseCount;
export const useSuspenseFindFirstFactoid: Hooks['useSuspenseFindFirst'] = hooks.useSuspenseFindFirst;
export const useSuspenseFindManyFactoid: Hooks['useSuspenseFindMany'] = hooks.useSuspenseFindMany;
export const useSuspenseFindUniqueFactoid: Hooks['useSuspenseFindUnique'] = hooks.useSuspenseFindUnique;
export const useSuspenseGroupByFactoid: Hooks['useSuspenseGroupBy'] = hooks.useSuspenseGroupBy;
export const useSuspenseInfiniteFindManyFactoid: Hooks['useSuspenseInfiniteFindMany'] = hooks.useSuspenseInfiniteFindMany;
export const useUpdateFactoid: Hooks['useUpdate'] = hooks.useUpdate;
export const useUpdateManyFactoid: Hooks['useUpdateMany'] = hooks.useUpdateMany;
export const useUpdateManyAndReturnFactoid: Hooks['useUpdateManyAndReturn'] = hooks.useUpdateManyAndReturn;
export const useUpsertFactoid: Hooks['useUpsert'] = hooks.useUpsert;
